if (!customElements.get('solution-portfolio')) {
  class SolutionPortfolio extends HTMLElement {
    connectedCallback() {
      this.toggles = [...this.querySelectorAll('[data-solution-toggle]')];
      this.panels = [...this.querySelectorAll('[data-solution-panel]')];
      this.cards = [...this.querySelectorAll('[data-solution-card]')];
      this.grid = this.querySelector('[data-solution-grid]');
      this.inline = this.hasAttribute('data-solution-inline') && this.grid !== null;

      this.toggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const id = toggle.dataset.solutionToggle;
          const isOpen = toggle.getAttribute('aria-expanded') === 'true';
          isOpen ? this.close(id, true) : this.open(id);
        });
      });

      this.querySelectorAll('[data-solution-close]').forEach((button) => {
        button.addEventListener('click', () => {
          const panel = button.closest('[data-solution-panel]');
          if (panel) this.close(panel.dataset.solutionPanel, true);
        });
      });

      if (window.Shopify?.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('[data-solution-card]');
          if (card) this.open(card.dataset.solutionCard);
        });
      }
    }

    /* Schiebt das Feld hinter die letzte Kachel derselben Zeile. Ohne das
       ginge es direkt hinter der angeklickten Kachel auf und würde die
       restlichen Kacheln dieser Zeile in die nächste drücken. Die Zeile wird
       über offsetTop bestimmt, damit es bei einer, zwei oder drei Spalten
       gleichermaßen stimmt. Muss laufen, solange alle Felder zu sind — ein
       offenes Feld verschiebt sonst die Messung. */
    placeInline(id) {
      const panel = this.panels.find((item) => item.dataset.solutionPanel === id);
      const card = this.cards.find((item) => item.dataset.solutionCard === id);
      if (!panel || !card) return;

      const cell = card.closest('li');
      if (!cell || cell.parentElement !== this.grid) return;

      const zeile = this.cards
        .map((item) => item.closest('li'))
        .filter((item) => item && item.parentElement === this.grid && item.offsetTop === cell.offsetTop);

      const letzte = zeile[zeile.length - 1] || cell;
      if (panel.previousElementSibling !== letzte) {
        this.grid.insertBefore(panel, letzte.nextSibling);
      }
    }

    open(id) {
      /* Die Stelle merken, an der geklickt wurde. Beim Schließen wird genau
         dorthin zurückgesetzt. Das ist verlässlicher als das Zurückholen der
         Kachel „in den Blick": Oberhalb der Kachel ändert sich beim Aufklappen
         nichts, die Zahl stimmt also auch später noch. */
      this.scrollBeimOeffnen = window.scrollY;

      this.panels.forEach((panel) => { panel.hidden = true; });
      if (this.inline) this.placeInline(id);

      this.panels.forEach((panel) => { panel.hidden = panel.dataset.solutionPanel !== id; });
      this.toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', String(toggle.dataset.solutionToggle === id)));
      this.cards.forEach((card) => card.classList.toggle('is-active', card.dataset.solutionCard === id));

      const panel = this.panels.find((item) => item.dataset.solutionPanel === id);
      if (panel) {
        requestAnimationFrame(() => {
          const bounds = panel.getBoundingClientRect();
          if (bounds.bottom > window.innerHeight || bounds.top < 0) {
            panel.scrollIntoView({ behavior: this.scrollVerhalten(), block: 'nearest' });
          }
        });
      }
    }

    close(id, restoreFocus = false) {
      const panel = this.panels.find((item) => item.dataset.solutionPanel === id);
      const toggle = this.toggles.find((item) => item.dataset.solutionToggle === id);
      const card = this.cards.find((item) => item.dataset.solutionCard === id);
      if (panel) panel.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (card) card.classList.remove('is-active');

      /* Beim Schließen fällt der Text weg, und der Blick landet auf dem
         Abschnitt darunter. preventScroll, weil der Browser dem Fokus sonst
         selbst hinterherspringt und die Rückkehr überschreibt. */
      if (restoreFocus && toggle) toggle.focus({ preventScroll: true });

      if (restoreFocus && typeof this.scrollBeimOeffnen === 'number') {
        window.scrollTo({ top: this.scrollBeimOeffnen, behavior: this.scrollVerhalten() });
        this.scrollBeimOeffnen = undefined;
      }
    }

    scrollVerhalten() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }
  }

  customElements.define('solution-portfolio', SolutionPortfolio);
}

if (!customElements.get('market-carousel')) {
  class MarketCarousel extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-market-rail]');
      this.section = this.closest('.nx-markets');
      this.previousButton = this.section?.querySelector('[data-market-previous]');
      this.nextButton = this.section?.querySelector('[data-market-next]');

      if (!this.rail || !this.previousButton || !this.nextButton) return;

      this.previousButton.addEventListener('click', () => this.scroll(-1));
      this.nextButton.addEventListener('click', () => this.scroll(1));
      this.rail.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      window.addEventListener('resize', () => this.updateButtons(), { passive: true });
      this.updateButtons();
    }

    scroll(direction) {
      const card = this.rail.querySelector('.nx-market-card');
      if (!card) return;
      const gap = Number.parseFloat(getComputedStyle(this.rail).columnGap) || 0;
      this.rail.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }

    updateButtons() {
      const maximum = this.rail.scrollWidth - this.rail.clientWidth;
      this.previousButton.disabled = this.rail.scrollLeft <= 2;
      this.nextButton.disabled = this.rail.scrollLeft >= maximum - 2;
    }
  }

  customElements.define('market-carousel', MarketCarousel);
}
